
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-interviews",
      function () {
        return require("private-next-pages/video-interviews.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-interviews"])
      });
    }
  